export default "__VITE_ASSET__DBJHJyMW__"